export default __webpack_public_path__ + "static/media/quote-gray.82f1d519.svg";